module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-818-retro-min.20186284.jpg";